import classNames from 'classnames';
import React from 'react';

export const UpgradeMessage = props => {
	const { className, children } = props;
	const elementCls = classNames('common-upgrade-msg', className);

	return (
		<div className={elementCls}>
			<p className="upgrade-icon-container">
				<span className="upgrade-icon" />
			</p>
			<div className="upgrade-text">{children}</div>
		</div>
	);
};
